import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import VueAxios from 'vue-axios'
import * as echarts from 'echarts';

import "./assets/css/base.css"
import "./assets/iconfont/iconfont.css"

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(VueAxios, axios);

import request from "./utils/request_new.js"
import requestForReport from "./utils/requestForReport.js"
import formatTime from "./utils/formatTime.js"
import numberToLetter from "./utils/numberToLetter.js"
import * as authorityData from "./utils/authority.js"
import * as systemBaseData from "./utils/systemBaseData.js"

import * as baseData from './assets/js/base.js'

Vue.prototype.$request = request
Vue.prototype.$requestForReport = requestForReport
Vue.prototype.$formatTime = formatTime
Vue.prototype.$numberToLetter = numberToLetter
Vue.prototype.$authorityData = authorityData
Vue.prototype.$systemBaseData = systemBaseData

Vue.prototype.$baseData = baseData
Vue.prototype.$echarts = echarts

// Vue.prototype.$baseurl = 'http://23.31.115.102:80' /// 服务器
// Vue.prototype.$baseurl = 'http://172.20.10.5:3724' // 胡
Vue.prototype.$baseurl = 'http://exam.ah-cz.cn' // 199服务器
    // Vue.prototype.$baseurl = 'http://47.98.44.199:3724' // 199服务器
    // Vue.prototype.$baseurl = 'http://8.142.77.55:3724' // 服务器
    // Vue.prototype.$baseurl = "http://192.168.0.120:3724" // 本地

Vue.prototype.$copyright = "Copyright © 安徽弛振科技有限公司版权所有"


Vue.prototype.$questionType = [
    { label: "单选题", value: "0", icon: "iconfont icon-danxuanti" },
    { label: "多选题", value: "1", icon: "iconfont icon-duoxuanti" },
    { label: "填空题", value: "2", icon: "iconfont icon-tiankongti" },
    { label: "判断题", value: "3", icon: "iconfont icon-icon-" },
    { label: "简答题", value: "4", icon: "iconfont icon-jiandati" },
]


import diy_table from "./components/diy_table"
Vue.use(diy_table)

import ueditor_dialog from "./components/ueditor_dialog"
Vue.use(ueditor_dialog)

import dep_user_tree from "./components/dep_user_tree"
Vue.use(dep_user_tree)

import diy_dialog from "./components/diy_dialog"
Vue.use(diy_dialog)

import diy_nothing from "./components/nothing"
Vue.use(diy_nothing)

import hasShow from './utils/hasShow.js'
Vue.directive('has', hasShow)


//引入拖拽排序插件
import VueDND from 'awe-dnd'
Vue.use(VueDND)

// 添加请求拦截器，在请求头中加token
axios.interceptors.request.use(
    config => {
        if (window.sessionStorage.getItem('token')) {
            config.headers.token = window.sessionStorage.getItem('token')
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    });

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')